<template>
    <div class="personal-goal-card">
        <div class="dashboard-chart">
            <design-2021-apprentice-radial-bar-chart-component
                :series="getConvertedGradeScore()"
                height="250"
                width="250"
                :options="chartOptions">
            </design-2021-apprentice-radial-bar-chart-component>
        </div>
        <div class="description">
            {{ personalGoalGradeIn.personal_goal.name }}

            <b-button
                class="btn-show-all btn-personal-goal-stats"
                v-if="personalGoalGradeIn.gradable_moment_id !== 0"
                variant="primary"
                @click="showStats">
                meer
            </b-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-combined-personal-goal-card-component',
        props: {
            personalGoalGradeIn: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                chartOptions: {
                    chart: {
                        type: 'radialBar',
                        offsetY: -20,
                        sparkline: {
                            enabled: true,
                        },
                    },
                    plotOptions: {
                        radialBar: {
                            startAngle: -90,
                            endAngle: 90,
                            track: {
                                background: '#e8eced',
                                strokeWidth: '97%',
                                margin: 5, // margin is in pixels
                                dropShadow: {
                                    enabled: true,
                                    top: 2,
                                    left: 0,
                                    color: '#999',
                                    opacity: 1,
                                    blur: 2,
                                },
                            },
                            dataLabels: {
                                name: {
                                    show: true,
                                },
                                value: {
                                    show: false,
                                    offsetY: -2,
                                    fontSize: '22px',
                                },
                            },
                        },
                    },
                    grid: {
                        padding: {
                            top: -10,
                        },
                    },
                    colors: [function({ value }) {
                        if (value < 26) {
                            return '#FF0046';
                        } else if (value < 51) {
                            return '#fd7e14';
                        } else if (value < 76) {
                            return '#FFD600';
                        } else {
                            return '#61CC13';
                        }
                    }],

                    labels: [this.personalGoalGradeIn.grade],
                },
            };
        },

        methods: {
            getConvertedGradeScore() {
                switch (this.personalGoalGradeIn.grade) {
                    case 'Onvoldoende':
                        return [25];
                    case 'Matig':
                        return [50];
                    case 'Voldoende':
                        return [75];
                    case 'Goed':
                        return [100];
                    default:
                        return [0];
                }
            },

            showStats() {
                let statsData = {
                    title: this.personalGoalGradeIn.personal_goal.name,
                    seriesName: 'Beoordeling',
                    seriesData: this.personalGoalGradeIn.personal_goal.grades.map((grade) => {
                        switch (grade.grade) {
                            case 'Onvoldoende':
                                return 25;
                            case 'Matig':
                                return 50;
                            case 'Voldoende':
                                return 75;
                            case 'Goed':
                                return 100;
                        }
                    }),
                    xAxisCategories: this.personalGoalGradeIn.personal_goal.grades.map((grade) => grade.created_at),
                };
                this.$emit('show-stats', statsData);
            },
        },
    };
</script>

<style scoped lang="scss">
    .personal-goal-card {
        margin-bottom: $grid-gutter-width;
    }

    .description {
        font-size: 1.1225rem;
        font-weight: $font-weight-bold;
        z-index: 50;

        .btn-show-all {
            font-size: $default-font-size;
            font-weight: $font-weight-medium;
            margin-top: map-get($grid-gutter-spacing, 'eight');
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'xxl')) {
        .personal-goal-card {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            column-gap: map-get($grid-gutter-spacing, 'fifteen');

            ::v-deep .dashboard-chart {
                .radial-bar-chart {
                    > div {
                        width: 250px;
                    }
                }
            }

            .description {
                font-size: 1.125rem;
                flex: 1 1 auto;

                .btn-personal-goal-stats {
                    line-height: 1;
                    font-size: $base-font-size;
                    margin-top: map-get($grid-gutter-spacing, 'four');
                }
            }
        }
    }
</style>
